module.exports = __webpack_public_path__ + "img/zcwjno.7e8666fc.png";